import { SoftwallDismissEvent } from "./utils";

export type AdBlockerType =
  | "ab"
  | "abp"
  | "opr"
  | "ublock"
  | "brave"
  | "adguard"
  | "ublockorigin"
  | "unknown";
export type InstructionType = AdBlockerType | "opr_ab";

export type SoftwallRecoveredType = "AA" | "AB" | "SCA";
export type DismissData = Pick<SoftwallDismissEvent, "element" | "tab">;
export type PageViewEventType =
  | "aa_pageview"
  | "ab_pageview"
  | "non_ab_pageview";

export type CountryCodeMode = "including" | "excluding";

export type BeforeUnloadOption = "subscribe" | "unsubscribe";

export type PrebidEventData = {
  adUnitCode?: string;
  creativeId?: string | number;
  bidder?: string;
};

export type Prebid = {
  bidderSettings: {
    standard: {
      adserverTargeting: {
        key: string;
        val: () => string;
      }[];
    };
  };
  adUnits: {
    code: string;
  }[];
  onEvent(event: string, callback: (event: PrebidEventData) => void): void;
};

interface GPTSlot {
  getSlotElementId: () => string;
}

export type GoogleTag = {
  pubadsReady: boolean;
  cmd: {
    push: (fn: () => void) => void;
  };
  pubads: () => {
    setTargeting: (key: string, value: string) => void;
    getSlots: () => {
      getSlotElementId: () => string;
    }[];
    addEventListener(
      event: string,
      callback: (event: {
        slot: GPTSlot;
        sourceAgnosticCreativeId: string | null;
        slotContentChanged: boolean;
        isEmpty: boolean;
      }) => void,
    ): void;
  };
};

export interface AADetectionResults {
  ab: boolean;
  acceptable: boolean;
}
export interface ConsentMetaData {
  tcDataDefined: boolean;
  gdprApplies?: boolean;
}
export interface ConsentCheckResults {
  consentShownInCurrentPV: boolean;
  isConsentGiven: boolean;
  meta: ConsentMetaData;
}

export interface UserLocalStorageState {
  renderDate?: Date;
  recoveryType?: SoftwallRecoveredType;
  attributionExpiry?: number;
}

export enum StorageType {
  Session = "session",
  Local = "local",
}

export enum IframeAction {
  Get = "get-data",
  Set = "set-data",
  Delete = "remove-data",
}

export enum ExtensionAction {
  GetStatus = "get-extension-status",
  Allowlist = "allowlist-website",
}

export enum MessageType {
  Storage = "storage",
  Extension = "extension",
}

export enum ExtensionEventType {
  Detected = "extension-detected",
  ApiStatus = "extension-api-status",
}

export enum ResponseStatus {
  Success = "success",
  Error = "error",
  Pending = "pending",
}

export enum ResponseSource {
  Storage = "bt-rlink-storage",
  Extension = "bt-rlink-extension",
}

export interface IframeMessage {
  action: IframeAction | ExtensionAction;
  key?: string;
  storageType?: StorageType;
  value?: unknown;
  payload?: unknown;
  trustedRLEvent: boolean;
  messageType: MessageType;
}

export interface ExtensionStatusResponse {
  name: string;
  version: string;
  requestId: string;
  result?: {
    license: string | null;
    aa: boolean;
    allowlist: {
      status: boolean;
      origin?: string;
      expiresAt?: number;
    };
  };
  error?: string;
}

export interface AllowlistResponse {
  name: string;
  version: string;
  requestId: string;
  result?: {
    status: boolean;
    created: number;
    origin: string;
    expiresAt?: number;
  };
  error?: string;
}

export interface IframeResponse<T = unknown> {
  status: ResponseStatus;
  value?: T;
  error?: string;
  source: ResponseSource;
}

export interface ExtensionEvent {
  type: ExtensionEventType;
  value?: unknown;
  available?: boolean;
}
